module.exports = __webpack_public_path__ + "img/chart_sort.b1bbdd67.svg";